import { Tag } from 'antd';
import { toLower, upperFirst } from 'lodash';

import { AuditTrailResponse } from 'codegen';
import { TColumn } from 'types';

export const columns: TColumn<AuditTrailResponse>[] = [{
  type: TColumn.type.Date,
  width: 120,
  title: 'Date (UTC)',
  dataIndex: 'dateTime',
  dateFormat: 'YYYY/MM/DD hh:mm:ss A',
}, {
  width: 150,
  title: 'Event type',
  dataIndex: 'eventType',
}, {
  width: 100,
  title: 'Actor id',
  dataIndex: 'collectorId',
  render: (collectorId, { opsUserId, opsUserRole }) => {
    let actorId = '';

    if (opsUserId && opsUserRole) {
      actorId = `${upperFirst(toLower(opsUserRole))}: ${opsUserId}`;
    }

    if (collectorId) {
      actorId = `Collector: ${collectorId}`;
    }

    if (actorId) {
      return (
        <Tag key={actorId}>
          {actorId}
        </Tag>
      );
    }

    return '';
  },
}, {
  width: 250,
  title: 'Details',
  dataIndex: 'metadata',
  render: (metadata) => {
    const details = metadata ? Object.keys(metadata).map((metaKey) => `${metaKey}: ${metadata[metaKey]}`) : [];

    if (details.length) {
      return (
        details.map((detail) => (
          <Tag key={detail}>
            {detail}
          </Tag>
        ))
      );
    }

    return 'No Details';
  },
}];
